import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocaleService } from '@app/core/i18n';
import { environment } from '@env/environment';

@Component({
  selector: 'vc-footer-legals',
  templateUrl: './footer-legals.component.html',
  styleUrls: ['./footer-legals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterLegalsComponent implements OnInit {
  @Input()
  legals: IlegalFooter;

  @Input()
  home: boolean;

  @Input()
  showAccessibilityLink: boolean;

  defaultHost = environment.envName === 'dev' ? 'http://' : '';
  accessibilityStatementLink = this.defaultHost + environment.legacyLink + '/accessibility-statement/';
  public modifierClass = 0;
  private legalsToAnchor = ['legal-mentions'];

  constructor(private localeService: LocaleService) {}

  ngOnInit() {
    const lang = this.localeService.getLocale()['language'];
    if (lang !== 'en') {
      this.accessibilityStatementLink = this.accessibilityStatementLink.replace(/www/, lang);
    }
  }

  isAnchor({ obfuscate, mnemonic }) {
    return !obfuscate && this.home && this.legalsToAnchor.includes(mnemonic);
  }

  isDisplayed(legal): boolean {
    if (legal.mnemonic === 'promotional-offers-conditions') {
      return false;
    }
    if (legal.mnemonic === 'dgccrf') {
      return this.localeService.getLanguage() === 'fr' && this.localeService.getCountry() === 'FR';
    }

    return true;
  }
}

export interface IlegalFooter {
  id: number;
  mnemonic: string;
  link: string;
  target: string;
  name: string;
  obfuscate: boolean;
}
